import styled from 'styled-components';

// colors
import {grey, darkGrey} from '@drivesally/sally-ui/lib/libs/colors';

// An OR-group requirement - same look as a plain Attribute chip, but with a
// border to visually distinguish "any one of these" from a single required field.
const GroupAttribute = styled.div`
  background: ${grey};
  border: 1px dashed ${darkGrey};
  padding: 5px;
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > i {
    color: ${darkGrey};
  }
`;

export default GroupAttribute;
